import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_2 = { class: "card mb-5 mb-xxl-0 g-xxl-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Активний запит")
  ])
], -1)
const _hoisted_4 = { class: "card-body pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationNotice = _resolveComponent("ExclamationNotice")!

  return (_ctx.user_no_money_request)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ExclamationNotice, {
              bg: "bg-light-success",
              border: "border-success",
              margin: "mt-1",
              icon: "media/icons/duotune/general/gen043.svg",
              iconClass: "svg-icon-success",
              header: "Запит по балансу!",
              msg: `Ваш запит надіслано на розгляд менеджера.
            <br/>
            <small>телефон: ${_ctx.user_no_money_request.phone}</small>
            <br/>
            <small>дата запиту: ${_ctx.user_no_money_request.created_at}</small>
            `
            }, null, 8, ["msg"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}